import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ReactTestPage from './ReactTestPage';

// Mount React app when container exists (e.g. <div id="react-root"></div> in a Razor view)
const rootElement = document.getElementById('react-root');
if (rootElement) {
  const root = createRoot(rootElement);
  const page = rootElement.dataset.page;
  const Component = page === 'react-test' ? ReactTestPage : App;
  root.render(<Component />);
}
